// Tema ESCURO — irmão do light.ts (EASYJUR-5735 / EJ-5580).
// Valores ancorados nos tokens DARK oficiais do Design System @easyjur/design-system@1.0.7
// (CDN jsdelivr, [data-ds-theme=dark]). Mesmas chaves do light.ts.
//
// DS 1.0.7 dark (referência): body-bg #191919 · gray-100 #F9F9F9 → gray-900 #191919
//   primary(brand) #E5293F (mantido) · secondary #ACBAC2 · success #3EA64D
//   info #19A2E6 · warning #CA8A04 · danger #EF4444 · white #FFFFFF
//
// Regra de ouro: cada chave é o par dark do MESMO uso no light (não mexe no light).
// Cores semânticas preservam o matiz (RN-03). "// era #XXXX" = valor no light.

const baseColors = {
    pureWhite: '#FFFFFF', // texto/ícone sobre cor (não escurece no dark)
    // ==== tokens auto-gerados pelo codemod (golden rule: light == hex original) ====
    c000000: '#E9ECEF',
    c0078d7: '#0078d7',
    c16a34a: '#16a34a',
    c1a202c: '#E9ECEF',
    c1e293b: '#E9ECEF',
    c1e3a8a: '#395298',
    c1e40af: '#3957B9',
    c1f2937: '#E9ECEF',
    c212529: '#E9ECEF',
    c2d3748: '#E9ECEF',
    c374151: '#E9ECEF',
    c495057: '#E9ECEF',
    c4a5568: '#E9ECEF',
    c64748b: '#E9ECEF',
    c64748b4d: '#E9ECEF',
    c6b7280: '#E9ECEF',
    c6c757d: '#E9ECEF',
    c6d6d6d: '#E9ECEF',
    c718096: '#E9ECEF',
    c797979: '#E9ECEF',
    c7c3aed: '#8C52EF',
    c808080: '#E9ECEF',
    c92400e: '#9F572B',
    c94a3b8: '#C5CED7',
    c999999: '#C5CED7',
    c9ca3af: '#C5CED7',
    ca0a096: '#C5CED7',
    ca0aec0: '#9CA3AF',
    ca8a8a8: '#C5CED7',
    cbe185d: '#C63470',
    cc1c1c1: '#9CA3AF',
    cc9243a: '#CF3E52',
    ccbd5e0: '#303030',
    ccbd5e1: '#303030',
    cd1d5db: '#303030',
    cd32f2f: '#D84848',
    cd41e35: '#D9394D',
    cdbeafe: '#303030',
    cdc2626: '#E04040',
    cdc3545: '#dc3545',
    cdcfce7: '#242424',
    ce0e0e0: '#303030',
    ce2e8f0: '#303030',
    ce3f2fd: '#242424',
    ce53e3e: '#e53e3e',
    ce5e5e5: '#303030',
    ce5e7eb: '#303030',
    ce9ecef: '#303030',
    ced354e: '#ed354e',
    ced354e1a: '#ed354e1a',
    cedf2f7: '#242424',
    cf0f0f0: '#242424',
    cf0fdf4: '#242424',
    cf1f1f1: '#242424',
    cf1f5f9: '#242424',
    cf1f5f94d: '#242424',
    cf3e8ff: '#303030',
    cf3f4f6: '#242424',
    cf3f7fb: '#242424',
    cf5f5f5: '#242424',
    cf7fafc: '#242424',
    cf8f8f8: '#242424',
    cf8f9fa: '#242424',
    cf8fafc: '#242424',
    cf9fafb: '#242424',
    cfafcfd: '#242424',
    cfce7f3: '#303030',
    cfde8e8: '#303030',
    cfee2e2: '#303030',
    cfef2f2: '#242424',
    cfef3c7: '#242424',
    cffe5e8: '#303030',
    cfff7f8: '#242424',

    white: '#1F1F1F',            // era #FFF — superfície/card base
    background: '#161616',       // era #F6F8FA — fundo do app (atrás dos cards)
    backgroundMain: '#191919',   // era #F7F7FA — DS body-bg

    // Azuis (links/ações) — clarear p/ contraste; info DS #19A2E6
    primaryBlue100: '#5B79E0',   // era #4361CD
    primaryBlue200: '#4A68D6',   // era #3452C0
    primaryBlue300: '#3E5AC8',   // era #2E49A9
    primaryBlue400: '#6E8AE8',   // era #293F93
    primaryBlue500: '#5E7CE0',   // era #23367C
    primaryBlue600: '#8AA4F0',   // era #1A2858

    // Laranjas — acento quente; tint claro → escuro
    primaryOrange50: '#3D2A12',  // era #FFF2DE — pílula/badge de status (warning) visível no dark
    primaryOrange100: '#FFDEAE',
    primaryOrange200: '#FFCB7F',
    primaryOrange300: '#FEBE60',
    primaryOrange400: '#FDB141',
    primaryOrange500: '#FFA41F',
    primaryOrange600: '#FA9604',
    primaryOrange700: '#F18F00',

    // Verdes — sucesso/acento (DS success #3EA64D); tints claros → escuros
    secondaryGreen050: '#0C210F', // era #DDFAF4
    secondaryGreen100: '#0C210F', // era #B8FFF2
    secondaryGreen200: '#6DFFE5',
    secondaryGreen300: '#04FDD0',
    secondaryGreen400: '#02E8BE',
    secondaryGreen500: '#00D3AD',
    secondaryGreen600: '#03AD8F',

    // Pool (azul claro) — tints claros → escuros
    secondaryPool100: '#0D1E2A', // era #E4F5FF
    secondaryPool200: '#0F2535', // era #C1E8FF
    secondaryPool300: '#ABE0FE',
    secondaryPool400: '#88D3FE',
    secondaryPool500: '#70CBFF',
    secondaryPool600: '#23ACFA',

    // Danger (DS #EF4444) — mantém vermelho; tints claros → escuros
    interfaceDanger: '#EF4444',
    interfaceDanger100: '#3D1517', // era #FFEAED — pílula/badge de status (danger) visível no dark
    interfaceDanger200: '#5A1F22', // era #FFCACE
    interfaceDanger300: '#F39493',
    interfaceDanger400: '#EF4444', // era #F24343
    interfaceDanger500: '#F05057', // era #E81E26
    interfaceDanger600: '#FF6A70', // era #BB0007

    // Success (DS #3EA64D) — mantém verde; tints claros → escuros
    interfaceSuccess: '#3EA64D',
    interfaceSuccess100: '#173D26', // era #E7F8EB — pílula/badge de status (success) visível no dark
    interfaceSuccess200: '#1E4A2A', // era #C5EECE
    interfaceSuccess300: '#9EE4AF',
    interfaceSuccess400: '#5BCB7D', // era #0FC758 — texto verde de status mais claro p/ contraste no dark

    // Escala texto/superfície (100=mais claro → 500=texto forte). INVERTIDA.
    interfaceText100: '#232323',   // era #EAEEF3 — superfície sutil
    interfaceText200: '#383838',   // era #C5CED7 — borda
    interfaceText300: '#8A99A8',   // era #8A99A8 — muted, serve nos dois
    interfaceText400: '#C5CED7',   // era #5A646E — texto corpo → claro
    interfaceText500: '#F2F2F2',   // era #353A40 — texto forte → quase branco
    interfaceText600: '#F9F9F9',   // era #374151 — heading/título → quase branco

    interfacePure0: '#191919',     // era #FFF — DS body-bg (superfície base)
    interfacePure100: '#242424',   // era #F2F2F2 — card elevado
    interfacePure200: '#383838',   // era #CCCCCC — borda
    interfacePure400: '#9CA3AF',   // era #707070 — texto muted (ds gray-200)
    interfacePure500: '#E9ECEF',   // era #333333 — texto
    interfacePure600: '#F9F9F9',   // era #1C2225 — heading (ds gray-100)

    // Red — Marca (DS mantém #E5293F no dark)
    redDev: 'red',
    primaryRed50: '#2D0A0D',        // era #FFEAED — ds primary-bg-subtle
    primaryRed300: '#7E1925',       // era #ffbfc7
    primaryRed400: '#E5293F',       // era #E52940 — DS primary (mantido)
    primaryRed600: '#FFBFC7',       // era #7e1925 — ícone → tint claro

    secondaryGray: '#ACBAC2',       // era #7f919a — DS secondary
    tertiaryGray: '#585B5E',        // era #acbac2 — ds gray-800

    // Gray - Interface — invertido por luminância (escala dark DS)
    interfaceGray100: '#9CA3AF',    // era #798891
    interfaceGray200: '#585B5E',    // era #AFBDC5
    interfaceGray300: '#ACBAC2',    // era #54666F
    interfaceGray400: '#C5CED7',    // era #3E4B52
    interfaceGray500: '#9CA3AF',    // era #6F777E
    interfaceGray600: '#909294',    // era #969DA3 (ds gray-350)
    interfaceGray700: '#C5CED7',    // era #5A646E
    interfaceGray800: '#F9F9F9',    // era #1C2225
    interfaceGray900: '#585B5E',    // era #96a1a7 (input disable)

    // Texto
    interfaceTextPrimary: '#F2F2F2', // era #333333
    interfaceText: '#E9ECEF',        // era #020817
    interfaceTextGray: '#C5CED7',    // era #3E4B52

    // Bordas
    interfaceBorder100: '#383838',   // era #CCD6DB

    // Botões desabilitados
    disabledBg: '#383838',          // era #54666F
    disabledText: '#9CA3AF',        // era #FFFFFF
}

export const comum = {
    colors: {
        ...baseColors,
    }
}

export const admin = {
    colors: {
        ...baseColors,
    }
}

export const operador = {
    colors: {
        ...baseColors,
    }
}
